import React, {useState, useMemo, useEffect} from 'react';
import CheckBoxWithText from './SubComponents/CheckboxWithText/CheckboxWithText';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import OptionButton from './SubComponents/OptionButton/OptionButton';
import DescriptiveLink from './SubComponents/DescriptiveLink/DescriptiveLink';
import {isArrayValid} from '../../../Assets/functions/functions';

const FormActions = ({
  title,
  optionsArr,
  optionNotSelectedError,
  checkBoxNotCheckedError,
  checkBoxText,
  descriptiveLinksArr,
  btnText,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [aboveBtnError, setAboveBtnError] = useState('');

  useEffect(() => {
    if (selectedOption && aboveBtnError === optionNotSelectedError) {
      setAboveBtnError('');
    }
    if (selectedOption && !selectedOption.isCheckedRequired) {
      setAboveBtnError('');
    }
  }, [selectedOption]);

  useEffect(() => {
    if (isChecked && aboveBtnError === checkBoxNotCheckedError) {
      setAboveBtnError('');
    }
  }, [isChecked]);

  const handleBtnClick = () => {
    if (!selectedOption && optionNotSelectedError) {
      setAboveBtnError(optionNotSelectedError);
      return;
    }
    if (selectedOption?.isCheckedRequired && !isChecked) {
      setAboveBtnError(checkBoxNotCheckedError);
      return;
    }
    if (selectedOption.callback) {
      const {callback} = selectedOption;
      callback();
    }
  };

  return (
    <div className='form-actions-container'>
      <div className='form-actions'>
        <div className='options-and-title'>
          {title && <span className='title'>{title}</span>}
          {isArrayValid(optionsArr) && (
            <div className='options'>
              {optionsArr.map((option, index) => {
                return (
                  <OptionButton
                    key={index}
                    serviceName={option?.serviceName}
                    price={option?.price}
                    priceNote={option?.priceNote}
                    onSelect={() => setSelectedOption({...option, key: index})}
                    isSelected={selectedOption?.key === index}
                  />
                );
              })}
            </div>
          )}
        </div>

        {checkBoxText && <CheckBoxWithText text={checkBoxText} callback={setIsChecked} />}

        {isArrayValid(descriptiveLinksArr) && (
          <div className='descriptive-links'>
            {descriptiveLinksArr.map((link, index) => (
              <DescriptiveLink key={index} {...link} />
            ))}
          </div>
        )}
      </div>
      {btnText && (
        <div className='alert-btn-container'>
          {aboveBtnError && <span className='error-message'>{aboveBtnError}</span>}
          <BtnSubmit text={btnText} onclick={handleBtnClick} />
        </div>
      )}
    </div>
  );
};

export default FormActions;
